module.exports = __webpack_public_path__ + "static/media/javascript-data-structures.72ed82eb.jpg";